import React from 'react';
import DetailsContainer from './DetailsContainerFiles/DetailsContainer';
import { DetailsContextProvider } from './DetailsContainerFiles/DetailsContainerContext';

const DetailsContainerMain = () => {
    return (
        <DetailsContextProvider>
            <DetailsContainer />
        </DetailsContextProvider>

    )
}

export default DetailsContainerMain